/**
 * Downloads a CTE Pathway (aka, Program of Study) PDF file
 *
 * @param {object} pathway
 * @returns
 */
export default function downloadCTEPathway( pathway ) {
  const downloadURL = pathway.pdfURL;
  if ( !downloadURL ) return Promise.resolve();

	 return fetch( downloadURL )
    .then( res => res.blob() )
    .then( ( blob ) => {
      const url = window.URL.createObjectURL( blob );
      const a = document.createElement( 'a' );
      a.style.display = 'none';
      a.href = url;
      a.download = `${pathway.name || 'program'}.pdf`;
      document.body.appendChild( a );
      a.click();
      window.URL.revokeObjectURL( url );
    } )
    .catch( () => console.error( 'A problem occurred downloading this file. Please try again later.' ) );
}
